import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    minHeight: 425
  },
  animalOverviewText: {
    paddingLeft: theme.spacing(1)
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
    maxWidth: 180
  },
  withMargin: {
    margin: theme.spacing(1)
  },
  withMarginLeft: {
    marginLeft: theme.spacing(1)
  },
  withPadding: {
    padding: theme.spacing(1)
  },
  withPaddingLeft: {
    paddingLeft: theme.spacing(1)
  },
  withPaddingRight: {
    paddingRight: theme.spacing(1)
  },
  mdIcon: {
    fontSize: 36
  },
  hiddenIcon: {
    fontSize: 36,
    visibility: 'hidden'
  },
  genderButton: {
    minWidth: 50
  },
  pullRightGrid: {
    flex: 1,
    textAlign: 'right'
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  },
  tableHeader: {
    background: colors.defaultGrey
  },
  tableHeaderFooter: {
    background: colors.defaultGrey
  },
  titleHeader: {
    justifyContent: 'space-between'
  },
  centred: {
    alignItems: 'center'
  },
  h40: {
    height: 40
  },
  flexAlingCenter: {
    display: 'flex',
    alignItems: 'center'
  },
  width100: {
    width: '100%'
  },
  p16: {
    padding: 5
  },
  pb12: {
    paddingBottom: 12
  },
  mt12: {
    marginTop: 2
  },
  displayGrid: {
    display: 'grid'
  },
  weightsControl: {
    width: '100%',
    paddingTop: 26
  },
  weanedDaysControl: {
    width: '100%',
    paddingTop: 26
  },
  accordionSummary: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  compareSearchGrid: {
    textAlign: 'right',
    flex: 1
  }
}));
